import Icon from 'react-native-vector-icons/Ionicons';

export default Icon;
